export default "__VITE_ASSET__Dfch7$$Y__"